<template>
  <b-container fluid v-if="showSampleData" class="sample-view">
    <b-alert
        variant="warning"
        class="sample-view__pending-sample-warning"
        :show="showPendingWarning"
        v-html="pendingSampleMessage()"
    />
    <header-row
      :sample="sample"
      :show-only-alarmed-methods.sync="showOnlyAlarmedMethods"
    />
    <b-row>
      <b-col>
        <keep-alive>
          <alarm-level-params-panel
            class="mb-3"
            :asset-module-id="assetModuleId"
            :sample-id="sampleId"
            :expanded.sync="alarmLevelExpanded"
          />
        </keep-alive>
        <keep-alive
          v-for="ruleData in sample.summary"
          :key="ruleData.rule"
        >
          <rule-panel
            v-if="showRule(ruleData)"
            class="mb-3"
            :rule="ruleData.rule"
            :asset-module-id="assetModuleId"
            :sampleId="sample.id"
            :alarmed="ruleData.alarmed"
            :expanded.sync="ruleData.expanded"
            :show-only-alarmed-methods="showOnlyAlarmedMethods"
          />
        </keep-alive>
      </b-col>
    </b-row>
  </b-container>
  <s-empty-list
    v-else
   :loading="loading"
  />
</template>

<script>
import LoadingMixin from '@/services/loadingMixin';
import IndividualAnalysisService
  from '@/domain/services/installation/engineering/chromatography/individualAnalysis';
import RulePanel from './RulePanel';
import HeaderRow from './HeaderRow';
import AlarmLevelParamsPanel from './AlarmLevelParamsPanel';

export default {
  props: {
    sampleId: String,
    assetModuleId: String,
  },
  created() {
    this.loadSample();
  },
  components: {
    HeaderRow,
    AlarmLevelParamsPanel,
    RulePanel,
  },
  mixins: [
    LoadingMixin,
  ],
  data: () => ({
    sample: null,
    alarmLevelExpanded: true,
    showOnlyAlarmedMethods: false,
  }),
  methods: {
    pendingSampleMessage() {
      return this.$t('engineering.chromatography.methods-and-diagnostics.individual-analysis.pending-sample');
    },
    async loadSample() {
      this.startLoading();
      this.sample = null;
      try {
        await IndividualAnalysisService.getSampleSummary(
          this.assetModuleId,
          this.sampleId,
        ).then((response) => {
            this.sample = response;
        });
      } finally {
        this.endLoading();
      }
    },
    showRule(ruleData) {
      return !this.showOnlyAlarmedMethods || ruleData.alarmed;
    },
  },
  computed: {
    showPendingWarning() {
      return (this.sample || {}).pendingSample;
    },
    showSampleData() {
      return !this.loading && this.sample != null;
    },
  },
};
</script>
<style lang="sass" scoped>
  .sample-view
    &__pending-sample-warning
      width: 100%
      margin: 10px 0 0 0
      text-align: center
    ::v-deep
      .card
        box-shadow: 0 4px 4px rgba(0, 0, 0, 0.2)
      .accordion-panel__body
        border: 1px solid var(--color-gray-medium-light)
        border-radius: 5px
</style>
